module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lng_en":{"zero_products":"Sorry, no products found!"},"lng_zh":{"zero_products":"對不起，沒有找到產品！"},"lng_ko":{"zero_products":"죄송합니다. 상품을 찾을 수 없습니다! "}}')
  delete Component.options._Ctor
}
